import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon } from 'lucide-react';
const BUYERS = ['Carlos de Buenos Aires acaba de comprar este sistema', 'María de Córdoba acaba de comprar este sistema', 'Pedro de Rosario, Santa Fe acaba de comprar este sistema', 'Ana de Mendoza acaba de comprar este sistema', 'Luis de Tucumán acaba de comprar este sistema', 'Lucía de Salta acaba de comprar este sistema', 'Martín de Neuquén acaba de comprar este sistema', 'Florencia de Mar del Plata acaba de comprar este sistema', 'Diego de La Plata acaba de comprar este sistema', 'Valentina de San Juan acaba de comprar este sistema'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyerIndex, setCurrentBuyerIndex] = useState(0);
  useEffect(() => {
    const showPopup = () => {
      setCurrentBuyerIndex(prev => (prev + 1) % BUYERS.length);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show randomly every 15-30 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * 15000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-383">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      y: 20
    }} className="fixed bottom-4 left-4 z-40 max-w-xs bg-[#1E293B] border border-slate-700 rounded-lg shadow-xl p-3 flex items-center gap-3" data-id="element-384">
          <div className="bg-blue-500/20 p-2 rounded-full flex-shrink-0" data-id="element-385">
            <UserIcon className="w-5 h-5 text-blue-400" data-id="element-386" />
          </div>
          <p className="text-sm text-slate-200 leading-tight" data-id="element-387">
            {BUYERS[currentBuyerIndex]}
          </p>
        </motion.div>}
    </AnimatePresence>;
}